import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

// Cabeçalho de seção reaproveitado nos formulários "em cards" (Imóveis,
// Produtos) - ícone + título (+ subtítulo opcional), separando blocos
// dentro de um Card sem precisar de mais de um Card por seção.
const FormSectionHeader = ({ icon, title, subtitle }) => (
    <Stack direction="row" spacing={1.5} alignItems="center" mb={2.5}>
        <Box
            sx={{
                width: 40,
                height: 40,
                borderRadius: 2.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'primary.main',
                color: '#fff',
                flexShrink: 0
            }}
        >
            {icon}
        </Box>
        <Box>
            <Typography variant="subtitle1" fontWeight="700" lineHeight={1.2}>
                {title}
            </Typography>
            {subtitle && (
                <Typography variant="caption" color="text.secondary">
                    {subtitle}
                </Typography>
            )}
        </Box>
    </Stack>
);

export default FormSectionHeader;
